<template>
	<div class="transition-route-container">
		<router-view/>
	</div>
</template>

<script>
import { merge, isObject } from 'lodash';
export default {
	data() {
		return {
			toRoute: '',
			fromRoute: '',
		}
	},
	methods: {
		horizontal(backward = false, end = false) {
			let deltaX = (backward) ? '-100vw' : '100vw';
			deltaX = (end) ? 0 : deltaX;
			return {
				translateX: deltaX,
			};
		},
		vertical(backward = false, end = false) {
			let deltaY = (backward) ? '-100vh' : '100vh';
			deltaY = (end) ? 0 : deltaY;
			return {
				translateY: deltaY,
			};
		},
		fade(backward = false, end = false) {
			let deltaY = (backward) ? '-20vh' : '20vh';
			deltaY = (end) ? 0 : deltaY;
			const deltaOpacity = (end) ? '1' : '0';
			return {
				translateY: deltaY,
				opacity: deltaOpacity,
			};
		},
		enter(backward = false, end = false) {
			const deltaScale = (end) ? '1' : '0';
			return {
				scaleX: deltaScale,
				scaleY: deltaScale,
			};
		},
		animateRoute(backward = false) {
			const routeTransition = this.$router.$transition;
			if (!routeTransition) {
				return;
			}
			const initialState = {
				opacity: 0,
				duration: 0,
			};
			const transitionStart = this[routeTransition](backward);
			merge(initialState, transitionStart);
			const endingState = {
				opacity: 1,
				duration: 333,
			};
			const transitionEnd = this[routeTransition](backward, true);
			merge(endingState, transitionEnd);
			const target = this.$el;
			this.$anime.timeline({
				duration: 333,
				easing: 'easeInOutQuad',
			}).add({
				targets: target,
				keyframes: [initialState, endingState],
			}).finished.then(() => {
				this.$el.style.transform = '';
			});
		},
	},
	updated() {
		if (!isObject(this.toRoute) || !isObject(this.fromRoute)) {
			return;
		}
		const p1 = this.toRoute.priority || 0;
		const p2 = this.fromRoute.priority || 0;
		const backward = (p2 > p1);
		this.animateRoute(backward);
	},
	watch: {
		// eslint-disable-next-line object-shorthand
		'$route'(to, from) {
			this.toRoute = this.$router.$getTransition(to);
			this.fromRoute = this.$router.$getTransition(from);
		},
	},
};
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/TransitionRoute.vue